function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

function getRawSiteUrl(): string {
  if (typeof window === 'undefined') {
    return '/';
  }

  return window.__CP_BOOTSTRAP__?.siteUrl || '/';
}

export function getSiteBasepath(): string {
  if (typeof window === 'undefined') {
    return '/';
  }

  try {
    const url = new URL(getRawSiteUrl(), window.location.origin);
    return normalizePathname(url.pathname);
  } catch {
    return '/';
  }
}

export function getSiteHomeHref(): string {
  return getSiteBasepath();
}

export function getAppRelativePath(pathname: string): string {
  const normalizedPath = normalizePathname(pathname);
  const basepath = getSiteBasepath();

  if (basepath === '/') {
    return normalizedPath;
  }

  if (normalizedPath === basepath) {
    return '/';
  }

  if (normalizedPath.startsWith(`${basepath}/`)) {
    return normalizePathname(normalizedPath.slice(basepath.length));
  }

  return normalizedPath;
}

export function buildSiteHref(pathname: string): string {
  if (typeof window === 'undefined') {
    return pathname || '/';
  }

  const baseUrl = new URL(window.location.origin);
  const basepath = getSiteBasepath();
  baseUrl.pathname = basepath === '/' ? '/' : `${basepath.replace(/\/+$/, '')}/`;

  const relativeTarget = pathname.replace(/^\/+/, '');
  const url = new URL(relativeTarget || '.', baseUrl);

  return `${normalizePathname(url.pathname)}${url.search}${url.hash}` || getSiteHomeHref();
}

export function isPublicAuthPath(pathname: string): boolean {
  const relativePath = getAppRelativePath(pathname);
  return relativePath === '/login' || relativePath === '/register';
}
